import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { LoaderService } from 'src/app/services/loader.service';
import { ArchivoCoordenada } from 'src/app/models/entities/archivo-coordenada';
import { Archivo } from 'src/app/models/entities/archivo';

interface ProgramadoEjercidoDireccion {
    mes: string;
    modificadoRural: string;
    ejercidoRural: string;
    modificadoFederal: string;
    ejercidoFederal: string;
}

@Injectable({
    providedIn: 'root'
})
export class PdfUtils {

    constructor(private loaderScreenService: LoaderService) {
    }

    /**
     * Descarga un archivo pdf utilizando una plantilla html
     * @param orientacion  La orientacion que se le dará a las páginas, puede ser 'portrait' o 'landscape'. Utilizar TipoOrientacionEnum.
     * @param nombre  Nombre que se asignara al descargar el pdf
     */
    public descargarPdf(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let pdf = new jsPDF(
            // orientation: orientacion
            // 'landscape', "mm", "letter"
            'l', 'cm', 'letter', true
        );

        // pdf.internal.scaleFactor = 30;

        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();

        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 4,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };

        return new Promise((resolve, reject) => {

            html2canvas(document.getElementById('pdf'), configuracionCanvas)
                .then(primeraPagina => {
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('fotosPdf'), configuracionCanvas);
                })
                .then(segundaPagina => {
                    pdf.addPage();
                    let img = segundaPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('fotosPdfFull'), configuracionCanvas);
                })
                .then(terceraPagina => {
                    pdf.addPage();
                    let img = terceraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('fotosPdfEstructura'), configuracionCanvas);
                })
                .then(cuartaPagina => {
                    pdf.addPage();
                    let img = cuartaPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('fotosPdfProblema'), configuracionCanvas);
                })
                .then(quintaPagina => {
                    pdf.addPage();
                    let img = quintaPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    this.loaderScreenService.desactivarLoaderScreen();
                    pdf.save(`${new Date().getTime()}.pdf`);
                    resolve();
                })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public descargarFichaSinImagenes(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let pdf = new jsPDF(
            // orientation: orientacion
            // 'landscape', "mm", "letter"
            'l', 'cm', 'letter', true
        );

        // pdf.internal.scaleFactor = 30;

        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();

        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 5,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };

        return new Promise((resolve, reject) => {
            html2canvas(document.getElementById('pdf'), configuracionCanvas)
                .then(primeraPagina => {
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    // pdf.addImage(img, 'JPEG', 0, 0, 21.59, 27.94, undefined, 'FAST');

                    this.loaderScreenService.desactivarLoaderScreen();
                    pdf.save(`${new Date().getTime()}.pdf`);
                    resolve();
                })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public descargarNotaInformativa(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let pdf = new jsPDF(
            // orientation: orientacion
            // 'landscape', "mm", "letter"
            'l', 'cm', 'letter', true
        );

        // pdf.internal.scaleFactor = 30;

        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();

        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 5,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };

        return new Promise((resolve, reject) => {

            html2canvas(document.getElementById('pdf'), configuracionCanvas)
                .then(primeraPagina => {
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('croquis'), configuracionCanvas);
                })
                .then(segundaPagina => {
                    pdf.addPage();
                    let img = segundaPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    this.loaderScreenService.desactivarLoaderScreen();
                    pdf.save(`${new Date().getTime()}.pdf`);
                    resolve();
                })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public descargarPdfIncidenciaObra(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let pdf = new jsPDF(
            // orientation: orientacion
            // 'landscape', "mm", "letter"
            'p', 'cm', 'letter', true
        );

        // pdf.internal.scaleFactor = 30;

        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();

        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 5,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };

        return new Promise((resolve, reject) => {

            html2canvas(document.getElementById('pdf'), configuracionCanvas)
                .then(primeraPagina => {
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    // pdf.addImage(img, 'JPEG', 0, 0, 21.59, 27.94, undefined, 'FAST');

                    this.loaderScreenService.desactivarLoaderScreen();
                    pdf.save(`${new Date().getTime()}.pdf`);
                    resolve();
                })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public descargarCarpetaEjecutivaDeObra(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let pdf = new jsPDF(
            // orientation: orientacion
            // 'landscape', "mm", "letter"
            'l', 'cm', 'letter', true
        );

        // pdf.internal.scaleFactor = 30;

        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();

        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 4,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };

        return new Promise((resolve, reject) => {

            html2canvas(document.getElementById('portada'), configuracionCanvas)
                .then(primeraPagina => {
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('pdf'), configuracionCanvas);
                })
                .then(segundaPagina => {
                    pdf.addPage();
                    let img = segundaPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('pdfNotaInformativa'), configuracionCanvas);
                })
                .then(terceraPagina => {
                    pdf.addPage();
                    let img = terceraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('croquis'), configuracionCanvas);
                })
                .then(cuartaPagina => {
                    pdf.addPage();
                    let img = cuartaPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    // return html2canvas(document.getElementById('fotosPdf'), configuracionCanvas);
                    this.loaderScreenService.desactivarLoaderScreen();
                    pdf.save(`${new Date().getTime()}.pdf`);
                    resolve();
                })
                // .then(quintaPagina => {
                //     pdf.addPage();
                //     let img = quintaPagina.toDataURL('image/jpeg', 1.0);
                //     pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                //     return html2canvas(document.getElementById('fotosPdfFull'), configuracionCanvas);
                // })
                // .then(sextaPagina => {
                //     pdf.addPage();
                //     let img = sextaPagina.toDataURL('image/jpeg', 1.0);
                //     pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                //     return html2canvas(document.getElementById('fotosPdfEstructura'), configuracionCanvas);
                // })
                // .then(septimaPagina => {
                //     pdf.addPage();
                //     let img = septimaPagina.toDataURL('image/jpeg', 1.0);
                //     pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                //     return html2canvas(document.getElementById('fotosPdfProblema'), configuracionCanvas);
                // })
                // .then(octavaPagina => {
                //     pdf.addPage();
                //     let img = octavaPagina.toDataURL('image/jpeg', 1.0);
                //     pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                //     this.loaderScreenService.desactivarLoaderScreen();
                //     pdf.save(`${new Date().getTime()}.pdf`);
                //     resolve();
                // })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public descargarCarpetaEjecutivaSinImagenes(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let pdf = new jsPDF(
            // orientation: orientacion
            // 'landscape', "mm", "letter"
            'l', 'cm', 'letter', true
        );

        // pdf.internal.scaleFactor = 30;

        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();

        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 5,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };

        return new Promise((resolve, reject) => {
            html2canvas(document.getElementById('portada'), configuracionCanvas)
                .then(primeraPagina => {
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('pdf'), configuracionCanvas);
                })
                .then(primeraPagina => {
                    pdf.addPage();
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('pdfNotaInformativa'), configuracionCanvas);
                })
                .then(segundaPagina => {
                    pdf.addPage();
                    let img = segundaPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    return html2canvas(document.getElementById('croquis'), configuracionCanvas);
                })
                .then(terceraPagina => {
                    pdf.addPage();
                    let img = terceraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    this.loaderScreenService.desactivarLoaderScreen();
                    pdf.save(`${new Date().getTime()}.pdf`);
                    resolve();
                })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public descargarPresupuestosEstado(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let pdf = new jsPDF(
            // orientation: orientacion
            // 'landscape', "mm", "letter"
            'l', 'cm', 'letter', true
        );

        // pdf.internal.scaleFactor = 30;

        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();

        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 5,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };

        return new Promise((resolve, reject) => {

            html2canvas(document.getElementById('pdfPresupuestoEstado'), configuracionCanvas)
                .then(primeraPagina => {
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    this.loaderScreenService.desactivarLoaderScreen();
                    pdf.save(`${new Date().getTime()}.pdf`);
                    resolve();
                })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public async descargarPDFLarguilloCarta(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let doc = new jsPDF({
            orientation: 'l',
            format: 'letter'
        });
        let configuracionCanvas = {
            allowTaint: true,
            useCORS: true,
            scale: 1,
            dpi: 144,
            ignoreElements: function (element) {
                let ignorarBotonSatelite: boolean = element.classList.contains('gm-style-mtc') ? true : false;
                let ignorarIconosImagenes: boolean = element.hasAttribute('src') && element.src.includes('icono-multimedia') ? true : false;
                let ignorarIconosEstructuras: boolean = element.hasAttribute('src') && element.src.includes('icono-puente') ? true : false;
                let ignorarCheckBox: boolean = element.classList.contains('ui-chkbox') ? true : false;
                if (ignorarBotonSatelite) {
                    return true;
                }
                if (ignorarIconosImagenes) {
                    return true;
                }
                if (ignorarIconosEstructuras) {
                    return true;
                }
                if (ignorarCheckBox) {
                    return true;
                }
                return false;
            }
        };

        let logoBase64: string = await new Promise<string>((resolve, err) => {
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = () => {
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                canvas.height = img.naturalHeight;
                canvas.width = img.naturalWidth;
                ctx.drawImage(img, 0, 0);
                let uri = canvas.toDataURL('image/png', 1.0);
                let b64: string = uri.replace(/^data:image.+;base64,/, '');
                resolve(b64);
            };
            let url: string = '../../../../../assets/img/logo3.png';
            img.src = url;
        });
        doc.addImage(logoBase64, 'PNG', 15, 8, 95, 22, undefined, 'FAST');
        doc.setFont("Helvetica");
        doc.setFontStyle("bold");
        doc.setFontSize(12);
        doc.setTextColor(99, 37, 35);
        doc.text('Subsecretaría de Infraestructura', doc.internal.pageSize.getWidth() - 15, 17, null, null, "right");
        doc.setFontSize(10);
        doc.text("Larguillo", doc.internal.pageSize.getWidth() - 15, 22, null, null, "right");

        let width = doc.internal.pageSize.getWidth();
        let height = doc.internal.pageSize.getHeight();
        let canvasLarguillo: HTMLCanvasElement = await html2canvas(document.getElementById('pdf'), configuracionCanvas);
        let imagenLarguillo: string = canvasLarguillo.toDataURL('image/jpeg', 1.0);
        doc.addImage(imagenLarguillo, 'JPEG', 15, 35, width - 30, height - 75, undefined, 'FAST');
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);

    }

    public async descargarPDFLarguilloPlotter(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        //90cm x 60cm
        //90cm = 35.43in
        //60cm = 23.62in
        //Las pulgadas se debe multiplicar por 72 para ver bien el pdf
        let doc = new jsPDF(
            {
                orientation: 'l',
                unit: 'in',
                format: [1700.64, 2548.8]
            }
        )
        let configuracionCanvas = {
            allowTaint: true,
            useCORS: true,
            ignoreElements: function (element) {
                let ignorarBotonSatelite: boolean = element.classList.contains('gm-style-mtc') ? true : false;
                let ignorarIconosImagenes: boolean = element.hasAttribute('src') && element.src.includes('icono-multimedia') ? true : false;
                let ignorarIconosEstructuras: boolean = element.hasAttribute('src') && element.src.includes('icono-puente') ? true : false;
                let ignorarCheckBox: boolean = element.classList.contains('ui-chkbox') ? true : false;
                if (ignorarBotonSatelite) {
                    return true;
                }
                if (ignorarIconosImagenes) {
                    return true;
                }
                if (ignorarIconosEstructuras) {
                    return true;
                }
                if (ignorarCheckBox) {
                    return true;
                }
                return false;
            }
        };
        let width = doc.internal.pageSize.getWidth();
        let height = doc.internal.pageSize.getHeight();
        let canvasLarguillo: HTMLCanvasElement = await html2canvas(document.getElementById('pdf'), configuracionCanvas);
        let imagenLarguillo: string = canvasLarguillo.toDataURL('image/jpeg', 1.0);
        doc.addImage(imagenLarguillo, 'JPEG', 1, 3, width - 2, height - 6, undefined, 'FAST');
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);

    }

    public async descargarGraficaAvanceFinanciero(comentarios: { comentariosRurales: string, comentariosFederales: string }, programadoEjercidoDireccion: ProgramadoEjercidoDireccion[]): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let doc = new jsPDF({
            orientation: 'l'
        });
        let configuracionCanvas = {
            allowTaint: true,
            useCORS: true,
            scale: 1,
            dpi: 144,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };
        let logoBase64: string = await new Promise<string>((resolve, err) => {
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = () => {
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                canvas.height = img.naturalHeight;
                canvas.width = img.naturalWidth;
                ctx.drawImage(img, 0, 0);
                let uri = canvas.toDataURL('image/png', 1.0);
                let b64: string = uri.replace(/^data:image.+;base64,/, '');
                resolve(b64);
            };
            let url: string = '../../../../../assets/img/logo3.png';
            img.src = url;
        });
        let body: any = programadoEjercidoDireccion.map((ped: ProgramadoEjercidoDireccion) => {
            return [
                { content: ped.mes, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: ped.modificadoFederal === '0.00' ? '' : ped.modificadoFederal, styles: { halign: 'center', valign: 'middle' } },
                { content: ped.ejercidoFederal === '0.00' ? '' : ped.ejercidoFederal, styles: { halign: 'center', valign: 'middle' } },
                { content: ped.modificadoRural === '0.00' ? '' : ped.modificadoRural, styles: { halign: 'center', valign: 'middle' } },
                { content: ped.ejercidoRural === '0.00' ? '' : ped.ejercidoRural, styles: { halign: 'center', valign: 'middle' } }
            ]
        });

        doc.addImage(logoBase64, 'PNG', 15, 8, 95, 22, undefined, 'FAST');
        doc.setFont("Helvetica");
        doc.setFontStyle("bold");
        doc.setFontSize(12);
        doc.setTextColor(99, 37, 35);
        doc.text('Subsecretaría de Infraestructura', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
        doc.setFontSize(10);
        doc.text("Calendario PEF 2020", doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
        doc.text("Programado - Ejercido", doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");

        doc.autoTable({
            margin: { top: 50 },
            styles: {
                fontSize: 12,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: 1
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Mes', rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Carreteras Federales', colSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Caminos Rurales', colSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Modificado', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Modificado', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body
        });
        this.agregarNumeroPagina(doc);


        doc.addPage();
        this.agregarHeaderGraficaAvanceFinanciero(doc, logoBase64, "Caminos Rurales y Carreteras Federales");
        let canvasRuralesFederales: HTMLCanvasElement = await html2canvas(document.getElementById('rurales-federales'), configuracionCanvas);
        let imgRuralesFederales = canvasRuralesFederales.toDataURL('image/jpeg', 1.0);
        doc.addImage(imgRuralesFederales, 'JPEG', 0, 30, 290, 180, undefined, 'FAST');
        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.setTextColor(0, 0, 0);
        doc.text('Presupuesto programado vs ejercido', 150, 40, null, null, 'center');
        this.agregarNumeroPagina(doc);

        doc.addPage();
        this.agregarHeaderGraficaAvanceFinanciero(doc, logoBase64, "Caminos Rurales");
        let canvasRurales: HTMLCanvasElement = await html2canvas(document.getElementById('rurales'), configuracionCanvas);
        let imgRurales = canvasRurales.toDataURL('image/jpeg', 1.0);
        doc.addImage(imgRurales, 'JPEG', 0, 35, 240, 170, undefined, 'FAST');
        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.setTextColor(0, 0, 0);
        doc.text('Presupuesto programado vs ejercido', 140, 40, null, null, 'center');
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text('COMENTARIOS', doc.internal.pageSize.getWidth() - 20, 55, null, null, "right");
        doc.setFontSize(10);
        doc.setFontStyle("normal");
        let comentariosRurales = doc.splitTextToSize(comentarios.comentariosRurales === undefined ? "" : comentarios.comentariosRurales, 45);
        doc.text(comentariosRurales, doc.internal.pageSize.getWidth() - 60, 60);
        this.agregarNumeroPagina(doc);

        doc.addPage();
        this.agregarHeaderGraficaAvanceFinanciero(doc, logoBase64, "Carreteras Federales");
        let canvasFederales: HTMLCanvasElement = await html2canvas(document.getElementById('federales'), configuracionCanvas);
        let imgFederales = canvasFederales.toDataURL('image/jpeg', 1.0);
        doc.addImage(imgFederales, 'JPEG', 0, 35, 240, 170, undefined, 'FAST');
        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.setTextColor(0, 0, 0);
        doc.text('Presupuesto programado vs ejercido', 140, 40, null, null, 'center');
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text('COMENTARIOS', doc.internal.pageSize.getWidth() - 20, 55, null, null, "right");
        doc.setFontSize(10);
        doc.setFontStyle("normal");
        let comentariosFederales = doc.splitTextToSize(comentarios.comentariosFederales === undefined ? "" : comentarios.comentariosFederales, 45);
        doc.text(comentariosFederales, doc.internal.pageSize.getWidth() - 60, 60);
        this.agregarNumeroPagina(doc);
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }

    agregarNumeroPagina(doc: jsPDF) {
        let numeroPagina = doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        let pageSize = doc.internal.pageSize;
        let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
    }

    agregarHeaderGraficaAvanceFinanciero(doc: jsPDF, logoBase64: string, area: string) {
        doc.addImage(logoBase64, 'PNG', 15, 8, 95, 22, undefined, 'FAST');
        doc.setFont("Helvetica");
        doc.setFontStyle("bold");
        doc.setFontSize(12);
        doc.setTextColor(99, 37, 35);
        doc.text('Subsecretaría de Infraestructura', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
        doc.setFontSize(10);
        doc.text("Dirección General de Carreteras", doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
        doc.text("Avance financiero - " + area, doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
    }

    public descargarReporteFotografico(nombreEstado: string, nombreObra: string, logoBase64: string, imagenesCapaCompletado: ArchivoCoordenada[], imagenesCapaMetaActual: ArchivoCoordenada[], imagenesCapaEstructura: ArchivoCoordenada[], base64ImagenesCompletado: string[], base64ImagenesMetaActual: string[], base64ImagenesEstructura: string[]) {
        let doc = new jsPDF({
            orientation: 'l',
            compress: true
        });

        if (imagenesCapaCompletado.length === 0 && imagenesCapaMetaActual.length === 0 && imagenesCapaEstructura.length === 0) {
            this.agregarHeaderReporteFotografico(doc, logoBase64, nombreEstado, nombreObra);
            doc.setFontSize(12);
            doc.text("LA OBRA AÚN NO CUENTA CON FOTOGRAFÍAS", 145, 35 + 77, null, null, "center");
        }

        if (imagenesCapaCompletado.length > 0) {
            this.agregarHeaderReporteFotografico(doc, logoBase64, nombreEstado, nombreObra);
            this.agregarFotografiasCapa(doc, imagenesCapaCompletado, base64ImagenesCompletado, "CAPA COMPLETADO");
        }

        if (imagenesCapaMetaActual.length > 0) {
            if (imagenesCapaCompletado.length > 0) {
                doc.addPage();
            }
            this.agregarHeaderReporteFotografico(doc, logoBase64, nombreEstado, nombreObra);
            this.agregarFotografiasCapa(doc, imagenesCapaMetaActual, base64ImagenesMetaActual, "CAPA META ACTUAL");
        }

        if (imagenesCapaEstructura.length > 0) {
            if (imagenesCapaCompletado.length > 0 || imagenesCapaMetaActual.length > 0) {
                doc.addPage();
            }
            this.agregarHeaderReporteFotografico(doc, logoBase64, nombreEstado, nombreObra);
            this.agregarFotografiasCapa(doc, imagenesCapaEstructura, base64ImagenesEstructura, "CAPA ESTRUCTURA");
        }

        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }

    public agregarHeaderReporteFotografico(doc: jsPDF, logoBase64: string, nombreEstado: string, nombreObra: string) {
        doc.addImage(logoBase64, 'PNG', 15, 8, 95, 22, undefined, 'FAST');
        doc.setFont("Helvetica");
        doc.setFontStyle("bold");
        doc.setFontSize(12);
        doc.setTextColor(99, 37, 35);
        doc.text('REPORTE FOTOGRÁFICO', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
        doc.setFontSize(10);
        doc.text(nombreEstado, doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
        doc.text(nombreObra, doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
    }

    public agregarFotografiasCapa(doc: jsPDF, imagenesCapa: ArchivoCoordenada[], imagenesBase64: string[], tituloCapa: string) {
        doc.setFontSize(12);
        doc.text(tituloCapa, 145, 29, null, null, "center");
        doc.setFontSize(10);
        imagenesCapa.forEach((imagen: ArchivoCoordenada, indice: number) => {
            let descripcion: string = imagen.descripcion.length >= 70 ? imagen.descripcion.substring(0, 67) + "..." : imagen.descripcion;
            switch (indice) {
                case 0:
                    doc.setLineWidth(.5);
                    doc.addImage(imagenesBase64[indice], 'PNG', 15, 32, 130, 70, undefined, 'FAST');
                    doc.rect(15, 32, 130, 70);
                    doc.text(descripcion, 17, 32 + 78, null, null, "left");
                    doc.rect(15, 32 + 72, 130, 10);
                    break;
                case 1:
                    doc.setLineWidth(.5);
                    doc.addImage(imagenesBase64[indice], 'PNG', 15 + 135, 32, 130, 70, undefined, 'FAST');
                    doc.rect(15 + 135, 32, 130, 70);
                    doc.text(descripcion, 17 + 135, 32 + 78, null, null, "left");
                    doc.rect(15 + 135, 32 + 72, 130, 10);
                    break;
                case 2:
                    doc.setLineWidth(.5);
                    doc.addImage(imagenesBase64[indice], 'PNG', 15, 32 + 84, 130, 70, undefined, 'FAST');
                    doc.rect(15, 32 + 84, 130, 70);
                    doc.text(descripcion, 17, 32 + 162, null, null, "left");
                    doc.rect(15, 32 + 156, 130, 10);
                    break;
                case 3:
                    doc.setLineWidth(.5);
                    doc.addImage(imagenesBase64[indice], 'PNG', 15 + 135, 32 + 84, 130, 70, undefined, 'FAST');
                    doc.rect(15 + 135, 32 + 84, 130, 70);
                    doc.text(descripcion, 17 + 135, 32 + 162, null, null, "left");
                    doc.rect(15 + 135, 32 + 156, 130, 10);
                    break;
            }
        });
    }


    public descargarObrasConcluidas(body: any[], foot: any[], base64Img: any): void {

        let doc = new jsPDF('l');
        doc.autoTable({
            margin: { top: 28 },
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 7,
            },
            styles: {
                fontSize: 7,
                lineColor: [255, 255, 255],
                lineWidth: .5,
                valign: 'middle',
                cellPadding: { top: .85, right: 0.5, bottom: .85, left: 0.5 }
            },
            didDrawPage: (data: any) => {
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFont("Helvetica");
                doc.setFontStyle("bold");
                doc.setFontSize(12);
                doc.setTextColor(99, 37, 35);
                doc.text('INFORME DE OBRAS CONCLUIDAS', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.setFontSize(10);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Registro', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Estado', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Nombre de la obra', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Costo total MDP', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta total KM', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Fecha de inicio - Fecha de termino', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Fecha de término', styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ]
            ],
            body,
            foot
        });

        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }

    public descargarObrasCabeceras(body: any[], foot: any[], base64Img: any): void {

        let doc = new jsPDF('l');
        doc.autoTable({
            margin: { top: 28 },
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 7,
            },
            styles: {
                fontSize: 7,
                lineColor: [255, 255, 255],
                lineWidth: .5,
                valign: 'middle',
                cellPadding: { top: .85, right: 0.5, bottom: .85, left: 0.5 }
            },
            didDrawPage: (data: any) => {
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFont("Helvetica");
                doc.setFontStyle("bold");
                doc.setFontSize(10);
                doc.setTextColor(99, 37, 35);
                doc.text('INFORME DE CAMINOS DE ACCESO A CABECERAS MUNICIPALES ÍNDIGENAS DE OAXACA', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.setFontSize(9);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Registro', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Estado', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Nombre de la obra', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Costo total MDP', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta total KM', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Fecha de inicio - Fecha de termino', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Fecha de término', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta ejecutada hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Inversión 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Faltante por ejecutar MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta faltante de ejecutar KM', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance financiero MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance físico %', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ]
            ],
            body,
            foot
        });

        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }

    public descargarObrasCompromisos(body: any[], foot: any[], base64Img: any): void {

        let doc = new jsPDF('l');
        doc.autoTable({
            margin: { top: 28 },
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            styles: {
                fontSize: 6,
                lineColor: [255, 255, 255],
                lineWidth: .5,
                valign: 'middle',
                cellPadding: { top: .85, right: 0.5, bottom: .85, left: 0.5 }
            },
            didDrawPage: (data: any) => {
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFont("Helvetica");
                doc.setFontStyle("bold");
                doc.setFontSize(10);
                doc.setTextColor(99, 37, 35);
                doc.text('INFORME DE OBRAS COMPROMISO', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.setFontSize(9);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Registro', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Estado', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Nombre de la obra', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Costo total MDP', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta total KM', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Fecha de inicio - Fecha de termino', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Fecha de término', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta ejecutada hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Inversión 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Faltante por ejecutar MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta faltante de ejecutar KM', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance financiero MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance físico %', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ]
            ],
            body,
            foot
        });

        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }


    public descargarObrasCONAGO(body: any[], foot: any[], base64Img: any): void {
        let doc = new jsPDF('l');
        doc.autoTable({
            margin: { top: 28 },
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            styles: {
                fontSize: 6,
                lineColor: [255, 255, 255],
                lineWidth: .5,
                valign: 'middle',
                cellPadding: { top: .85, right: 0.5, bottom: .85, left: 0.5 }
            },
            didDrawPage: (data: any) => {
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFont("Helvetica");
                doc.setFontStyle("bold");
                doc.setFontSize(10);
                doc.setTextColor(99, 37, 35);
                doc.text('INFORME DE OBRAS DE CONAGO', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.setFontSize(9);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Registro', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Estado', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Nombre de la obra', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Costo total MDP', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta total KM', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Fecha de inicio - Fecha de termino', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Fecha de término', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta ejecutada hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Inversión 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Faltante por ejecutar MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta faltante de ejecutar KM', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance financiero MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance físico %', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ]
            ],
            body,
            foot
        });
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }




    public descargarObrasPrioritarias(body: any[], foot: any[], base64Img: any): void {
        let doc = new jsPDF('l');
        doc.autoTable({
            margin: { top: 28 },
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            styles: {
                fontSize: 6,
                lineColor: [255, 255, 255],
                lineWidth: .5,
                valign: 'middle',
                cellPadding: { top: .85, right: 0.5, bottom: .85, left: 0.5 }
            },
            didDrawPage: (data: any) => {
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFont("Helvetica");
                doc.setFontStyle("bold");
                doc.setFontSize(10);
                doc.setTextColor(99, 37, 35);
                doc.text('INFORME DE OBRAS PRIORITARIAS', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.setFontSize(9);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Registro', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Estado', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Nombre de la obra', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Costo total MDP', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta total KM', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Fecha de inicio - Fecha de termino', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Fecha de término', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta ejecutada hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Inversión 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Faltante por ejecutar MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta faltante de ejecutar KM', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance financiero MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance físico %', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ]
            ],
            body,
            foot
        });
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }


    public descargarObrasFONADIN(body: any[], foot: any[], base64Img: any): void {
        let doc = new jsPDF('l');
        doc.autoTable({
            margin: { top: 28 },
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            styles: {
                fontSize: 6,
                lineColor: [255, 255, 255],
                lineWidth: .5,
                valign: 'middle',
                cellPadding: { top: .85, right: 0.5, bottom: .85, left: 0.5 }
            },
            didDrawPage: (data: any) => {
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFont("Helvetica");
                doc.setFontStyle("bold");
                doc.setFontSize(10);
                doc.setTextColor(99, 37, 35);
                doc.text('INFORME DE OBRAS DE FONADIN', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.setFontSize(9);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Registro', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Estado', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Nombre de la obra', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Costo total MDP', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta total KM', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Fecha de inicio - Fecha de termino', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Fecha de término', styles: { minCellWidth: 18, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta ejecutada hasta 2019 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Inversión 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta 2020 MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Faltante por ejecutar MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Meta faltante de ejecutar KM', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance financiero MDP', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Avance físico %', styles: { minCellWidth: 12, halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ]
            ],
            body,
            foot
        });
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }

    public descargarSeguimientoPEF(bodyPrimerTabla: any[], footPrimerTabla: any[], bodySegundaTabla: any[], footSegundaTabla: any[], bodyTercerTabla: any[], footTercerTabla: any[], bodyCuartaTabla: any[], footCuartaTabla: any[], bodyQuintaTabla: any[], footQuintaTabla: any[], bodySextaTabla: any[], footSextaTabla: any[], base64Img: any, fechaFederal: string, fechaRural: string): void {

        let doc = new jsPDF('l');
        doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
        doc.setFont("Helvetica");
        doc.setFontStyle("bold");
        doc.setFontSize(12);
        doc.setTextColor(99, 37, 35);
        doc.text('SEGUIMIENTO PRESUPUESTO DE EGRESOS DE LA FEDERACION 2020', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
        doc.setFontSize(10);
        doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
        doc.text('Programa de Construcción y Modernizacion de Carreteras', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
        doc.autoTable({
            margin: { top: 28 },

            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 7,
            },
            styles: {
                fontSize: 7,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: { top: .85, right: 0.5, bottom: .85, left: 0.5 }
            },
            didDrawPage: (data: any) => {
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'No', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Registro SHCP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Carretera', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'PEF 2020 MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Autorizado Modifcado MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Contratado Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Calendario Acumulado Febrero MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Calendario al Primer Trimestre MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: `Ejercido ${fechaFederal}`, colSpan: 3, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Saldo (Calendario vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Saldo (Calendario 1er. Trimestre vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Trámite de pago', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIA', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIAFF', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body: bodyPrimerTabla,
            foot: footPrimerTabla
        });

        doc.addPage();
        doc.autoTable({
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            margin: { top: 28 },
            styles: {
                fontSize: 6,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: { top: .85, right: 1, bottom: .85, left: 1 }
            },
            didDrawPage: (data: any) => {
                doc.setTextColor(99, 37, 35);
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFontSize(12);
                doc.text('SEGUIMIENTO PRESUPUESTO DE EGRESOS DE LA FEDERACION 2020', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
                doc.setFontSize(10);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.text('Programa de Derecho de Vía de Carreteras Federales', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Estado', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'PEF 2020 MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Autorizado Modifcado MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Contratado Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Calendario Acumulado Febrero MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Calendario al Primer Trimestre MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: `Ejercido ${fechaFederal}`, colSpan: 3, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Saldo (Calendario vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Saldo (Calendario 1er. Trimestre vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Trámite de pago', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIA', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIAFF', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body: bodySegundaTabla,
            foot: footSegundaTabla
        });


        doc.addPage();
        doc.autoTable({
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            margin: { top: 28 },
            styles: {
                fontSize: 6,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: { top: .85, right: 1, bottom: .85, left: 1 }
            },
            didDrawPage: (data: any) => {
                doc.setTextColor(99, 37, 35);
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFontSize(12);
                doc.text('SEGUIMIENTO PRESUPUESTO DE EGRESOS DE LA FEDERACION 2020', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
                doc.setFontSize(10);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.text('Programa de Estudios y Proyectos de Carreteras Federales', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Estado', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'PEF 2020 MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Autorizado Modifcado MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Contratado Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Calendario Acumulado Febrero MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Calendario al Primer Trimestre MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: `Ejercido ${fechaFederal}`, colSpan: 3, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Saldo (Calendario vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Saldo (Calendario 1er. Trimestre vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Trámite de pago', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIA', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIAFF', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body: bodyTercerTabla,
            foot: footTercerTabla,
            theme: 'grid',
        });

        doc.addPage();
        doc.autoTable({
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            margin: { top: 28 },
            styles: {
                fontSize: 6,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: { top: .85, right: 1, bottom: .85, left: 1 }
            },
            didDrawPage: (data: any) => {
                doc.setTextColor(99, 37, 35);
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFontSize(12);
                doc.text('SEGUIMIENTO PRESUPUESTO DE EGRESOS DE LA FEDERACION 2020', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
                doc.setFontSize(10);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.text('Programa de Caminos Rurales y Alimentadores', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Estado', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'PEF 2020 MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Autorizado Modifcado MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Contratado Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Calendario Acumulado Febrero MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Calendario al Primer Trimestre MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: `Ejercido ${fechaRural}`, colSpan: 3, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Saldo (Calendario vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Saldo (Calendario 1er. Trimestre vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Trámite de pago', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIA', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIAFF', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body: bodyCuartaTabla,
            foot: footCuartaTabla
        });

        doc.addPage();
        doc.autoTable({
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            margin: { top: 28 },
            styles: {
                fontSize: 6,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: { top: .85, right: 1, bottom: .85, left: 1 }
            },
            didDrawPage: (data: any) => {
                doc.setTextColor(99, 37, 35);
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFontSize(12);
                doc.text('SEGUIMIENTO PRESUPUESTO DE EGRESOS DE LA FEDERACION 2020', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
                doc.setFontSize(10);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.text('Programa de Conservación de Carreteras (Caminos Rurales y Alimentadores)', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Estado', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'PEF 2020 MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Autorizado Modifcado MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Contratado Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Calendario Acumulado Febrero MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Calendario al Primer Trimestre MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: `Ejercido ${fechaRural}`, colSpan: 3, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Saldo (Calendario vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Saldo (Calendario 1er. Trimestre vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Trámite de pago', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIA', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIAFF', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body: bodyQuintaTabla,
            foot: footQuintaTabla
        });

        doc.addPage();
        doc.autoTable({
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            margin: { top: 28 },
            styles: {
                fontSize: 6,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: { top: .85, right: 1, bottom: .85, left: 1 }
            },
            didDrawPage: (data: any) => {
                doc.setTextColor(99, 37, 35);
                doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
                doc.setFontSize(12);
                doc.text('SEGUIMIENTO PRESUPUESTO DE EGRESOS DE LA FEDERACION 2020', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
                doc.setFontSize(10);
                doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
                doc.text('Programa de Estudios y Proyectos de Caminos Rurales y Alimentadores', doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Estado', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'PEF 2020 MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Autorizado Modifcado MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Contratado Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Calendario Acumulado Febrero MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Calendario al Primer Trimestre MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: `Ejercido ${fechaRural}`, colSpan: 3, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Saldo (Calendario vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Saldo (Calendario 1er. Trimestre vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Trámite de pago', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIA', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIAFF', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body: bodySextaTabla,
            foot: footSextaTabla,
            theme: 'grid',
        });
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }

    public descargarSeguimientoProgramas(bodyPrimerTabla: any[], footPrimerTabla: any[], base64Img: any, tituloHeader: string, fechaCreacion: string): void {

        let doc = new jsPDF('l');
        doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
        doc.setFont("Helvetica");
        doc.setFontStyle("bold");
        doc.setFontSize(12);
        doc.setTextColor(99, 37, 35);
        doc.text('SEGUIMIENTO PRESUPUESTO DE EGRESOS DE LA FEDERACION 2020', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
        doc.setFontSize(10);
        doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
        doc.text(tituloHeader, doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");
        doc.autoTable({
            margin: { top: 28 },

            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 7,
            },
            styles: {
                fontSize: 7,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: { top: .85, right: 0.5, bottom: .85, left: 0.5 }
            },
            didDrawPage: (data: any) => {
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'Estado', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'PEF 2020 MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Autorizado Modifcado MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Contratado Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Calendario Acumulado Febrero MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Calendario al Primer Trimestre MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: `Ejercido ${fechaCreacion}`, colSpan: 3, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Saldo (Calendario vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Saldo (Calendario 1er. Trimestre vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Trámite de pago', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIA', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIAFF', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body: bodyPrimerTabla,
            foot: footPrimerTabla
        });
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }

    public descargarSeguimientoPEFObras(bodySegundaTabla: any[], footSegundaTabla: any[], base64Img: any, tituloHeader: string, fechaCreacion: string): void {

        let doc = new jsPDF('l');
        doc.addImage(base64Img, 'JPEG', 15, 8, 95, 22, undefined, 'FAST');
        doc.setFont("Helvetica");
        doc.setFontStyle("bold");
        doc.setFontSize(12);
        doc.setTextColor(99, 37, 35);
        doc.text('SEGUIMIENTO PRESUPUESTO DE EGRESOS DE LA FEDERACION 2020', doc.internal.pageSize.getWidth() - 15, 15, null, null, "right");
        doc.setFontSize(10);
        doc.text('Dirección General de Carreteras', doc.internal.pageSize.getWidth() - 15, 20, null, null, "right");
        doc.text(tituloHeader, doc.internal.pageSize.getWidth() - 15, 25, null, null, "right");

        doc.autoTable({
            showFoot: 'lastPage',
            footStyles: {
                fillColor: [161, 32, 64],
                fontSize: 6,
            },
            margin: { top: 28 },
            styles: {
                fontSize: 6,
                halign: 'center',
                valign: 'middle',
                lineColor: [255, 255, 255],
                lineWidth: .5,
                cellPadding: { top: .85, right: 1, bottom: .85, left: 1 }
            },
            didDrawPage: (data: any) => {
                let numeroPagina = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                let pageSize = doc.internal.pageSize;
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(numeroPagina.toString(), doc.internal.pageSize.getWidth() - 17, pageHeight - 10);
            },
            didParseCell: (v) => this.enhanceWordBreak(v),
            head: [
                [
                    { content: 'No', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Registro SHCP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Carretera', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'PEF 2020 MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Autorizado Modifcado MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Contratado Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Calendario Acumulado Febrero MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Calendario al Primer Trimestre MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: `Ejercido ${fechaCreacion}`, colSpan: 3, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Total MDP', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Saldo (Calendario vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    // { content: 'Saldo (Calendario 1er. Trimestre vs Ejercido)', colSpan: 1, rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
                [
                    { content: 'Trámite de pago', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIA', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } },
                    { content: 'Ejercido SIAFF', colSpan: 1, rowSpan: 1, styles: { halign: 'center', valign: 'middle', fillColor: [161, 32, 64] } }
                ],
            ],
            body: bodySegundaTabla,
            foot: footSegundaTabla,
            theme: 'grid',
        });
        this.loaderScreenService.desactivarLoaderScreen();
        doc.save(`${new Date().getTime()}.pdf`);
    }

    public descargarPresupuestosProgramas(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let pdf = new jsPDF(
            // orientation: orientacion
            // 'landscape', "mm", "letter"
            'l', 'cm', 'letter', true
        );
        // pdf.internal.scaleFactor = 30;
        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();
        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 5,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };
        return new Promise((resolve, reject) => {
            html2canvas(document.getElementById('pdfPresupuestosProgramas'), configuracionCanvas)
                .then(primeraPagina => {
                    let img = primeraPagina.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(img, 'JPEG', 0, 0, width, height, undefined, 'FAST');
                    this.loaderScreenService.desactivarLoaderScreen();
                    pdf.save(`${new Date().getTime()}.pdf`);
                    resolve();
                })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }


    public enhanceWordBreak({ doc, cell, column }) {
        if (cell === undefined) {
            return;
        }

        const hasCustomWidth = (typeof cell.styles.cellWidth === 'number');

        if (hasCustomWidth || cell.raw == null || cell.colSpan > 1) {
            return
        }

        let text;

        if (cell.raw instanceof Node) {
            text = cell.raw.innerText;
        } else {
            if (typeof cell.raw == 'object') {
                // not implemented yet
                // when a cell contains other cells (colSpan)
                return;
            } else {
                text = '' + cell.raw;
            }
        }

        // split cell string by spaces
        const words = text.split(/\s+/);

        // calculate longest word width
        const maxWordUnitWidth = words.map(s => Math.floor(doc.getStringUnitWidth(s) * 100) / 100).reduce((a, b) => Math.max(a, b), 0);
        const maxWordWidth = maxWordUnitWidth * (cell.styles.fontSize / doc.internal.scaleFactor)

        const minWidth = cell.padding('horizontal') + maxWordWidth;

        // update minWidth for cell & column

        if (minWidth > cell.minWidth) {
            cell.minWidth = minWidth;
        }

        if (cell.minWidth > cell.wrappedWidth) {
            cell.wrappedWidth = cell.minWidth;
        }

        if (cell.minWidth > column.minWidth) {
            column.minWidth = cell.minWidth;
        }

        if (column.minWidth > column.wrappedWidth) {
            column.wrappedWidth = column.minWidth;
        }
    }

}
